import React, { Fragment } from "react";
import { Row, Col, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../assets/css/scss/section/_imageTitleDescVert.scss";
import preventRightClick from "../../common/preventRightClick";

export default function ImageTitleDescVert(props: any) {
    const storyData = props?.story;
    const sizeOfItems = props?.size ? { ...props.size } : {};
    console.log("asdddd >", storyData);
    return (
        <div className="story-block-section">
            <Row>
                {storyData?.map((data: any) => (
                    <Fragment>
                        {data?.identifier ? (
                            <Col
                                {...sizeOfItems}
                                // md={4}
                                // xl={3}
                                className="px-0 mb-3 mb-lg-4 mb-xl-0 theme-bg-white story-img-wrapper"
                            >
                                <div className="story-img-item">
                                    <Link
                                        to={
                                            props?.link && data?.identifier
                                                ? `/${props?.link}/${data?.identifier}`
                                                : data?.identifier
                                                ? `/${data?.identifier}`
                                                : "/"
                                        }
                                        className="w-100"
                                    >
                                        <Image
                                            src={
                                                data?.image ||
                                                "/assets/images/story-blog.jpg"
                                            }
                                            alt="story"
                                            className="w-100"
                                            fluid
                                            onContextMenu={(e) =>
                                                preventRightClick(e)
                                            }
                                        />
                                    </Link>
                                </div>
                                {data?.title ? (
                                    <h3 className="h4 px-4 bold line-clamp-2 mt-3">
                                        <Link
                                            to={
                                                props?.link && data?.identifier
                                                    ? `/${props?.link}/${data?.identifier}`
                                                    : data?.identifier
                                                    ? `/${data?.identifier}`
                                                    : "/"
                                            }
                                        >
                                            {data.title}
                                        </Link>
                                    </h3>
                                ) : null}
                                {data?.subtitle ? (
                                    <p className="px-4 font-14 line-clamp-3 mt-1">
                                        {data.subtitle}
                                    </p>
                                ) : null}
                            </Col>
                        ) : null}
                    </Fragment>
                ))}
                {/* <Col md={4} xl={3} className="mb-3 mb-lg-4 mb-xl-0">
                    <div className="story-img-item mb-3">
                        <Link to="/" className="w-100">
                            <Image
                                src="/assets/images/story-blog.jpg"
                                alt="story"
                                className="w-100"
                                fluid
                            />
                        </Link>
                    </div>
                    <h3 className="h4 bold">
                        <Link to="/">Washington National 2021 Prospects Chat</Link>
                    </h3>
                    <p className="font-14">
                        Lorem ipsum dolor sit ame consecte tur adipiscing elit, sed do
                        eiusmod tempor incididunt ut our labore et dolore magna aliquac uis
                        ipsum.
                    </p>
                </Col>
                <Col md={4} xl={3} className="mb-3 mb-lg-4 mb-xl-0">
                    <div className="story-img-item mb-3">
                        <Link to="/" className="w-100">
                            <Image
                                src="/assets/images/story-blog.jpg"
                                alt="story"
                                className="w-100"
                                fluid
                            />
                        </Link>
                    </div>
                    <h3 className="h4 bold">
                        <Link to="/">
                            Glaser: Baseball’s Golden age of Young Talent Is Now
                        </Link>
                    </h3>
                    <p className="font-14">
                        Lorem ipsum dolor sit ame consecte tur adipiscing elit, sed do
                        eiusmod tempor incididunt ut our labore et dolore magna aliquac uis
                        ipsum.
                    </p>
                </Col>
                <Col md={4} xl={3} className="mb-3 mb-lg-4 mb-xl-0">
                    <div className="story-img-item mb-3">
                        <Link to="/" className="w-100">
                            <Image
                                src="/assets/images/story-blog.jpg"
                                alt="story"
                                className="w-100"
                                fluid
                            />
                        </Link>
                    </div>
                    <h3 className="h4 bold">
                        <Link to="/">
                            2020 All-MLB First and Second Teams and Their Status
                        </Link>
                    </h3>
                    <p className="font-14">
                        Lorem ipsum dolor sit ame consecte tur adipiscing elit, sed do
                        eiusmod tempor incididunt ut our labore et dolore magna aliquac uis
                        ipsum.
                    </p>
                </Col> */}
            </Row>
        </div>
    );
}
